<template>
  <section class="parcours-mini-footer" aria-label="À découvrir aussi">
    <div class="parcours-mini-footer__divider"></div>
    <p class="parcours-mini-footer__title">À découvrir aussi</p>
    <p class="parcours-mini-footer__links">
      <router-link :to="{ name: 'dem_subscription' }" class="parcours-mini-footer__link">
        <span class="parcours-mini-footer__emoji" aria-hidden="true">🚗</span>
        <span class="parcours-mini-footer__name">DEM</span>
      </router-link>
      <span class="parcours-mini-footer__sep" aria-hidden="true">|</span>
      <router-link :to="{ name: 'aywa_subscription' }" class="parcours-mini-footer__link">
        <span class="parcours-mini-footer__emoji" aria-hidden="true">🏍️</span>
        <span class="parcours-mini-footer__name">AYWA</span>
      </router-link>
      <span class="parcours-mini-footer__sep" aria-hidden="true">|</span>
      <router-link :to="{ name: 'tukki_subscription' }" class="parcours-mini-footer__link">
        <span class="parcours-mini-footer__emoji" aria-hidden="true">🌍</span>
        <span class="parcours-mini-footer__name">TUKKI</span>
      </router-link>
    </p>
  </section>
</template>

<script>
export default {
  name: 'ParcoursMiniFooter'
};
</script>

<style scoped>
.parcours-mini-footer {
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
  padding: 40px 16px 48px;
  text-align: center;
  font-family: 'Lato', 'Roboto', sans-serif;
}

.parcours-mini-footer__divider {
  width: 60px;
  height: 3px;
  margin: 0 auto 20px;
  background: linear-gradient(90deg, transparent 0%, #ffa409 50%, transparent 100%);
  border-radius: 2px;
}

.parcours-mini-footer__title {
  margin: 0 0 16px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 2.5px;
  text-transform: uppercase;
  color: #9a9a9a;
}

.parcours-mini-footer__links {
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px 14px;
  font-size: 16px;
  font-weight: 700;
}

.parcours-mini-footer__link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 999px;
  color: #2b2b2b;
  text-decoration: none;
  letter-spacing: 0.6px;
  transition: color 0.2s ease, background-color 0.2s ease, transform 0.2s ease;
}

.parcours-mini-footer__link:hover,
.parcours-mini-footer__link:focus-visible {
  color: #ffa409;
  background-color: rgba(255, 164, 9, 0.08);
  transform: translateY(-1px);
  outline: none;
}

.parcours-mini-footer__link:focus-visible {
  box-shadow: 0 0 0 2px rgba(255, 164, 9, 0.45);
}

.parcours-mini-footer__emoji {
  font-size: 18px;
  line-height: 1;
}

.parcours-mini-footer__sep {
  color: #d8d8d8;
  font-weight: 300;
  user-select: none;
}

@media (max-width: 600px) {
  .parcours-mini-footer {
    padding: 32px 12px 40px;
  }
  .parcours-mini-footer__divider {
    width: 48px;
    margin-bottom: 16px;
  }
  .parcours-mini-footer__title {
    font-size: 10px;
    letter-spacing: 2px;
    margin-bottom: 12px;
  }
  .parcours-mini-footer__links {
    font-size: 14px;
    gap: 4px 8px;
  }
  .parcours-mini-footer__link {
    padding: 5px 8px;
  }
  .parcours-mini-footer__emoji {
    font-size: 16px;
  }
}
</style>
